import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit, tranfer_payment_method } from "../../Config";
import { capitalizeFirstLetter, formatAmount, getTransferStatusConfig, handleCopy, truncateText } from "../../helpers";
import { IoCopySharp } from "react-icons/io5";
import moment from "moment";
import Tooltip from "../Tooltip";
import { MdOutlineChevronRight } from "react-icons/md";

const PayoutHistoryTable = ({
    apiData,
    setSelectedData,
    setViewDetails
}) => {

    const storageKey = `transfer_active_id_page`;
    const [data, setData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [openActionMenu, setOpenActionMenu] = useState(null);

    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };

    // Load saved page index
    const storageValue = sessionStorage.getItem(storageKey);
    const savedPage = storageValue !== null ? Number(storageValue) : 0;
    const [currentPage, setCurrentPage] = useState(savedPage);

    useEffect(() => {
        setCurrentPage(savedPage);
    }, [savedPage]);

    const view = (item) => {
        setViewDetails(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };
    const ActionBtns = (item) => (
        <Tooltip label="View details">
            <button
                onClick={() => view(item)}
                className="px-4 ml-auto text-gray-400 hover:text-gray-700 transition"
            >
                <MdOutlineChevronRight size={22} />
            </button>
        </Tooltip>
    );
    // Get payment method label
    const getPaymentMethodLabel = (methodValue) => {
        const method = tranfer_payment_method.find(m => m.value === methodValue);
        return method ? method.label : "NA";
    };

    // Format date using moment
    const formatDate = (date) => {
        if (!date) return "NA";
        return moment(date).format("DD, MMM YY, hh:mm A");
    };

    useEffect(() => {
        if (apiData && apiData.length > 0) {
            const tempData = apiData.map((item) => ({
                name: getName(item),
                amount: getAmount(item),
                // status: getStatusBadge(item),
                mode: getTransferMethodWithStatus(item),
                utr: getUtr(item),
                date: getDate(item),
                status: getTransferStatus(item),
                action: ActionBtns(item),
                utrNo: getUtr(item),
                rawData: item
            }));
            setData(tempData);
        } else if (apiData && apiData.length === 0) {
            setData([]);
        }
    }, [apiData, openActionMenu]);

    const getAmount = (item) => {
        return (
            <Tooltip label={item?.remark || ''} classname="cursor-default">
                <Amount>₹{formatAmount(item?.amount)}</Amount>
            </Tooltip>
        )
    };

    const getName = (item) => (
        <div className="flex items-start gap-3 cursor-pointer">
            {/* Avatar */}
            <div className="relative shrink-0">
                <img
                    src={Images.Avatar}
                    alt={item.name}
                    className="w-9 h-9 rounded-full object-cover"
                />
            </div>

            {/* Name */}
            <div className="flex flex-col min-w-0">
                <span className="font-medium text-gray-600 truncate">
                    {capitalizeFirstLetter(truncateText(item?.name || "Unknown", 20))}
                </span>
                <div className="flex items-center gap-1 text-xs text-gray-400">
                    <span>#{item?.transId || "NA"}</span>
                    {item?.transId && (
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                handleCopy(item.transId);
                            }}
                            className="hover:text-gray-600 transition"
                            title="Copy ID"
                        >
                            <IoCopySharp size={12} />
                        </button>
                    )}
                </div>
            </div>
        </div>
    );

    const getTransferMethodWithStatus = (item) => {
        // const { label, dotColor } = getTransferStatusConfig(item.status);

        return (
            <div className="flex items-center gap-2">
                {/* <Tooltip label={label}>
                    <span className={`w-2 h-2 rounded-full ${dotColor}`} />
                </Tooltip> */}

                <span className="text-sm text-gray-600">
                    {getPaymentMethodLabel(item?.transferMethod)}
                </span>
            </div>
        );
    };

    const getTransferStatus = (item) => {
        const { label, color } = getTransferStatusConfig(item.status);
        return (
            <div className="flex items-center gap-2">
                {/* <Tooltip label={label}>
                    <span className={`w-2 h-2 rounded-full ${dotColor}`} />
                </Tooltip> */}

                <span className={`text-sm font-semibold ${color} !bg-white`}>
                    {label}
                </span>
            </div>
        );
    };

    const getUtr = (item) => (
        <div className="flex flex-col">
            <span className="text-sm text-gray-600">
                {item?.transferUtr || "-"}
            </span>
        </div>
    );

    const getDate = (item) => {
        const date = moment(item?.updatedAt);

        return (
            <div className="flex items-center">
                <div className="flex flex-col px-1 py-2 rounded-2xl duration-200">
                    {/* Date */}
                    <span className="text-sm text-gray-600 tracking-tight">
                        {date.format("DD MMM YYYY")}
                    </span>

                    {/* Time */}
                    <div className="flex items-center gap-1 mt-0.5">
                        <span className="text-xs uppercase tracking-widest text-gray-400">
                            {date.format("hh:mm A")}
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {
            return [
                {
                    Header: "Name",
                    accessor: "name",
                },
                {
                    Header: "Amount",
                    accessor: "amount",
                },
                {
                    Header: "Status",
                    accessor: "status",
                },
            ];
        }

        return [
            {
                Header: "Name",
                accessor: "name",
            },
            {
                Header: "Amount",
                accessor: "amount",
            },
            {
                Header: "Mode",
                accessor: "mode",
            },
            {
                Header: "UTR No",
                accessor: "utrNo",
            },
            {
                Header: "Status",
                accessor: "status",
            },
            {
                Header: "Processed",
                accessor: "date",
            },
            {
                Header: "",
                accessor: "action",
            },
        ];
    }, [isMobileView]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex },
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );

    useEffect(() => {
        if (pageIndex !== undefined) {
            sessionStorage.setItem(storageKey, pageIndex);
        }
    }, [pageIndex, storageKey]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup, idx) => (
                        <Tr {...headerGroup.getHeaderGroupProps()} key={idx}>
                            {headerGroup.headers.map((column, colIdx) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())} key={colIdx}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr
                                    {...row.getRowProps({ style: { height: "80px" } })}
                                    hasdata={(apiData?.length > 0).toString()}
                                >
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                                style={{ maxWidth: "320px" }}
                                                key={cellIndex}
                                            >
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr key={`expanded-${rowIndex}`}>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">
                                                <li className="flex justify-between">
                                                    <strong>Amount:</strong>
                                                    <span>₹{data[rowIndex]?.rawData?.amount?.toLocaleString('en-IN') || "0"}</span>
                                                </li>
                                                <li className="flex justify-between">
                                                    <strong>Method:</strong>
                                                    <span>{getPaymentMethodLabel(data[rowIndex]?.rawData?.method)}</span>
                                                </li>

                                                <li className="flex justify-between">
                                                    <strong>UTR / Transaction ID:</strong>
                                                    <span >{data[rowIndex]?.rawData?.utr || data[rowIndex]?.rawData?.transactionId || "NA"}</span>
                                                </li>
                                                <li className="flex justify-between">
                                                    <strong>Date & Time:</strong>
                                                    <span>{formatDate(data[rowIndex]?.rawData?.createdAt || data[rowIndex]?.rawData?.date)}</span>
                                                </li>
                                                <li className="flex justify-between">
                                                    <strong>Action:</strong>
                                                    <span>{formatDate(data[rowIndex]?.rawData?.createdAt || data[rowIndex]?.rawData?.action)}</span>
                                                </li>
                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
        </>
    );
};

const CustomTable = tw.table` w-full text-gray-600 `;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Amount = tw.p`
  text-gray-800 
  text-sm 
  font-semibold 
  bg-neutral-100 
  px-3 
  py-1 
  rounded-full 
  inline-flex 
  min-w-[80px]
  justify-center
`;
export default PayoutHistoryTable;